export const getCharacterizedWarningMessage = (productName: string) =>
  `You are about to edit COMPLETED modeling for ${productName}. This will make ${productName} private and remove completed characterization. You will be required to re-characterize.`
